/*
 * File: fontawesome.js
 * Project: seesaw-marketplace-app
 *
 * Created by Brendan Michaelsen on June 16, 2022 at 1:32 PM
 * Copyright © 2022 Seesaw Technologies, LLC. All rights reserved.
 *
 * Last Modified: January 8, 2023 at 7:24 PM
 * Modified By: Brendan Michaelsen
 */

/**
 * Imports
 */

// Modules
import { library } from '@fortawesome/fontawesome-svg-core';

// Icons
import {
	faBagShopping,
	faBars,
	faTimes,
	faHeart,
	faCheck,
	faChevronDown,
	faChevronUp,
	faArrowRight
} from '@fortawesome/free-solid-svg-icons';


/**
 * Init
 */

export function loadIcons() {

	// Add icons to library
	library.add(
		faBagShopping,
		faBars,
		faTimes,
		faHeart,
		faCheck,
		faChevronDown,
		faChevronUp,
		faArrowRight
	);
}
